<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      resizable
      border
      row-id="amzFtyNoticeOutCode"
      size="small"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true, reserve: true }"
      @cell-click="onCellClick"
      @checkbox-change="onCheckboxChange"
      @checkbox-all="onCheckboxChange"
      ref="table"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.amzFtyNoticeOutStatus == 'Y'
              ? 'success'
              : row.amzFtyNoticeOutStatus == 'F'
              ? 'info'
              : row.amzFtyNoticeOutStatus == 'S'
              ? 'warning'
              : row.amzFtyNoticeOutStatus == 'D'
              ? 'danger'
              : ''
          "
        >
          {{ row.v_amzFtyNoticeOutStatus }}
        </el-tag>
        <br />
        <el-link
          v-if="row.amzFtyNoticeOutStatus == 'N' && row.cancelReason"
          type="danger"
          :underline="false"
          style="font-size: 13px;"
          class="ml-2"
          @click="cancel(row.amzFtyNoticeOutCode, row.cancelReason)"
        >
          {{ $l('form_title_reason') || '查看取消原因' }}
        </el-link>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <el-dialog
      :title="$l('dialog_title_cancel') || '取消出货'"
      :visible.sync="dialogVisible"
      width="500px"
      v-if="dialogVisible"
      :before-close="closeRejected"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="120px"
        label-position="top"
      >
        <el-form-item
          v-if="!form.visible"
          :label="$l('form_label_scmContactSeqno') || '供应商联系人'"
          prop="listScmContactSeqno"
        >
          <dict-select
            v-model="form.listScmContactSeqno"
            :body="scmSelectBody"
            :placeholder="$l('form_placeholder_scmContactSeqno') || '请选择联系人'"
            url="/digitalCenter/scmInfoContacts/select"
            clearable
            filterable
            multiple
            style="width: 100%"
            @loaded="onContactsLoaded"
          />
        </el-form-item>
        <el-form-item
          :label="$l('form_title_cancelReason') || '取消出货原因'"
          prop="cancelReason"
        >
          <el-input
            type="textarea"
            maxlength="500"
            show-word-limit
            :rows="6"
            :placeholder="
              $l('form_pl_title_cancelReason') || '请输入取消出货原因'
            "
            v-model="form.cancelReason"
            :disabled="form.visible"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeRejected">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!form.visible"
          @click="rejected"
        >
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
import { format } from '@/libs/util.number.js'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      format: (number) => format(number),
      tableColumns: tableColumns(this),
      form: {
        amzFtyNoticeOutCode: '',
        scmCode: '',
        cancelReason: '',
        listScmContactSeqno: [],
        visible: false,
      },
      scmSelectBody: { scmCode: '' },
      dialogVisible: false,
      rules: {
        listScmContactSeqno: [
          {
            type: 'array',
            required: true,
            message:
              this.$l('form_placeholder_scmContactSeqno') || '请选择联系人',
            trigger: 'change',
          },
        ],
        cancelReason: [
          {
            required: true,
            message:
              this.$l('form_pl_title_cancelReason') || '请输入取消出货原因',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    onCheckboxChange({ records, reserves }) {
      this.$emit('checkboxChange', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkboxChange', [])
    },
    // 避免点击操作列也会选择行
    onCellClick({ row, column }) {
      const { property } = column
      const filterColumns = [
        'checkbox',
        'defaultImageUrl',
        'col-opt',
        'amzFtyNoticeOutStatus',
      ]
      if (filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)
      const data = $table.getCheckboxRecords(true) || []
      const reserves = $table.getCheckboxReserveRecords(true) || []
      this.$emit('checkboxChange', data.concat(reserves))
    },
    optCommand({ opt, data }) {
      const { menuType } = opt
      switch (menuType) {
        case 'detail':
        case 'edit':
        case 'send':
        case 'confirm':
        case 'adjust':
        case 'generate':
          this.$emit('openEditPage', { pageType: menuType, data })
          break
        case 'delete':
          this.del(data)
          break
        case 'export':
          this.$emit('export', data, opt.data)
          break
        case 'printer':
          this.printer(data)
          break
        case 'download':
          this.$emit('download', data)
          break
        case 'copy':
          this.copy(data)
          break
        case 'cancel':
          this.cancel(data.amzFtyNoticeOutCode, '', data.scmCode)
          break
      }
    },
    cancel(amzFtyNoticeOutCode, cancelReason, scmCode = '') {
      this.dialogVisible = true
      this.form.amzFtyNoticeOutCode = amzFtyNoticeOutCode
      this.form.scmCode = scmCode
      this.form.cancelReason = cancelReason
      this.form.listScmContactSeqno = []
      this.form.visible = !!cancelReason
      this.scmSelectBody = { scmCode }
    },
    onContactsLoaded(options) {
      if (options && options.length === 1) {
        this.form.listScmContactSeqno = [options[0].value]
      }
    },
    async rejected() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      if (this.loadingOpen()) return
      this.$api
        .ecomAmzFtyNoticeOutCancelApi({
          amzFtyNoticeOutCode: this.form.amzFtyNoticeOutCode,
          cancelReason: this.form.cancelReason,
          listScmContactSeqno: this.form.listScmContactSeqno,
        })
        .then(async (res) => {
          this.loadingClose()
          const { status } = res
          if (status == 200) {
            this.$message({
              showClose: true,
              message: this.$l('form_title_cancelSuccess') || '取消成功',
              type: 'success',
            })
          }
          this.closeRejected()
          this.$emit('reload')
        })
        .catch(async () => {
          this.loadingClose()
        })
    },
    closeRejected() {
      this.dialogVisible = false
      this.form.cancelReason = ''
      this.form.amzFtyNoticeOutCode = ''
      this.form.scmCode = ''
      this.form.listScmContactSeqno = []
      this.form.visible = false
      this.scmSelectBody = { scmCode: '' }
    },
    del({ amzFtyNoticeOutCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .ecomAmzFtyNoticeOutDelApi({ amzFtyNoticeOutCode })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
      })
    },
    copy({ amzFtyNoticeOutCode }) {
      this.$confirm(
        this.$l('tips_copy') || '是否要复制该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .ecomAmzFtyNoticeOutCopyApi({ amzFtyNoticeOutCode })
          .then((res) => {
            const { status } = res || {}
            if (status !== 200) {
              this.$message.error(
                this.$l('INDEX.tips_copy_error') || '复制失败！'
              )
              return
            }
            this.$emit('openEditPage', {
              pageType: 'edit',
              data: {
                amzFtyNoticeOutCode: res.body.amzFtyNoticeOutCode,
                amzFtyNoticeOutNo: res.body.amzFtyNoticeOutNo,
              },
            })
          })
      })
    },
    printer({
      amzFtyNoticeOutCode,
      amzFtyNoticeOutNo,
      bookContractNo,
      scmName,
    }) {
      if (!amzFtyNoticeOutCode) return
      const now = new Date().getTime()
      this.$api.globalExportData(
        '/ecom/amz/fty/notice/out/print',
        { amzFtyNoticeOutCode },
        `${amzFtyNoticeOutNo}_${bookContractNo}_出库通知单_${scmName}_标签_${now}.pdf`
      )
    },
    showCancelReason({ cancelReason }) {
      this.$alert(cancelReason, '取消原因', {
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: this.$l('INDEX.btn_cancel') || '关闭',
      })
    },
  },
}
</script>
